import { inject, injectable } from 'inversify'
import {
  IAppErrorFactory,
  IInvestmentsService,
  IRemoveInvestmentUseCase,
  RemoveInvestmentUseCaseInput,
  RemoveInvestmentUseCaseOutput,
} from '../../types'
import symbols from '../../symbols'

@injectable()
export default class RemoveInvestmentInteractor implements IRemoveInvestmentUseCase {
  @inject(symbols.IInvestmentsService) private investmentsService: IInvestmentsService

  @inject(symbols.IAppErrorFactory) private errorFactory: IAppErrorFactory

  async handle(input: RemoveInvestmentUseCaseInput): Promise<RemoveInvestmentUseCaseOutput> {
    const output = this.getDefaultOutputData()
    try {
      output.investment = await this.investmentsService.removeInvestment(input)
    } catch (e) {
      output.error = this.errorFactory.create({
        originalInstance: e as Error,
        messageForUI: '投資先情報の削除に失敗しました',
      })
    }

    return output
  }

  private getDefaultOutputData(): RemoveInvestmentUseCaseOutput {
    return {
      investment: null,
      error: null,
    }
  }
}
